import React, { useCallback, useState, useEffect, useRef, useMemo } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from "../../../components/comm/Navbar";
import Header from "../../../components/comm/Head";
import URL from "../../../constants/url";
import style from './HospitalCare.module.css';
import Avatar from '@mui/material/Avatar';
import MedicalReservation from '../../../components/box/MedicalReservation';
import LocationInfoBox from '../../../components/box/LocationInfoBox';
import EmptyContentBox from '../../../components/box/EmptyContentBox';
import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';
import { formatDateWithWeekday, formatTime24 } from '../../../assets/js/comm';
import LocationImageView from '../../../components/box/LocationImageView';

import DialBox from '../../../components/comm/DialBox';

import Skeleton from '@mui/material/Skeleton';
// 탭 UI
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';


const HospitalCare = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

    const [mediInfo, setMediInfo] = useState();
    const [value, setValue] = React.useState(''); // 병원탭
    const [schedule, setSchedule] = React.useState('012_20250611'); // //날짜 탭
    const [hsptlConnectedInfo, setHsptlConnectedInfo] = useState([]);
    const [hsptlRsvtList, setHsptlRsvtList] = useState([]);
    const [hsptlRsvtInfoList, setHsptlRsvtInfoList] = useState([]);
    const [hsptlRsvtClnicList, setHsptlRsvtClnicList] = useState([]);
    const [hsptlRsvtClnicNonfaceList, setHsptlRsvtClnicNonfaceList] = useState([]);


    const [placeInfo, setPlaceInfo] = useState({});
    const [resvInfo, setResvInfo] = useState({});

    //로딩
    const [isLoading, setIsLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);

    const isFirstRender = useRef(true);

    const { hsptlCd = "", hsptlNm = "", resvOpen = "" } = location.state || {};

    useEffect(() => {

        if (isFirstRender.current) {
            isFirstRender.current = false;
            getHsptlInfo();
            return;
        }

    }, []);

    const setTabParam = useCallback((t, replace = true) => {
        const next = new URLSearchParams(searchParams);
        if (t) next.set('t', t);
        setSearchParams(next, { replace });
    }, [searchParams, setSearchParams]);

    const getHsptlInfo = useCallback(async () => {

        const url = "/hsptl/retrieveHsptlInfo";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            }
            , withCredentials: true
        }

        setIsLoading(true);

        await axiosApi.post(url, {}, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;

                console.table(mediInfo.hsptlRsvtList);
                console.table(mediInfo.hsptlRsvtInfoList);

                setMediInfo({...mediInfo});
                setHsptlConnectedInfo(mediInfo.hsptlConnectedInfo);
                setHsptlRsvtList(mediInfo.hsptlRsvtList);
                setHsptlRsvtInfoList(mediInfo.hsptlRsvtInfoList);
                setHsptlRsvtClnicList(mediInfo.hsptlRsvtClnicList);
                setHsptlRsvtClnicNonfaceList(mediInfo.hsptlRsvtClnicNonfaceList);

                setHasFetched(true);
                if(resvOpen){
                    setOpen(true);
                    setResvInfo({
                        hsptlCd : hsptlCd,
                        hsptlNm : hsptlNm
                    })
                }

            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })
        setIsLoading(false);
    }, [navigate]);




    useEffect(()=>{
        changeTabFirst(value);
    }, [value]);

    useEffect(()=>{

        const t = searchParams.get('t');
        const targetHsptl = sessionStorage.getItem("targetHsptl");

        if(t == null){
            if(targetHsptl == null){

                Array.isArray(hsptlRsvtList) &&
                hsptlConnectedInfo.map((item, index) => {
                    if(index === 0){
                        handleHsptlChange('', item.hsptlCd);
                    }
                });

                if(hsptlCd !== ''){
                    handleHsptlChange('',hsptlCd)
                }

            }else{

                Array.isArray(hsptlRsvtList) && handleHsptlChange('', targetHsptl);

                // Array.isArray(hsptlRsvtList) &&
                // hsptlConnectedInfo.map((item, index) => {
                    //if(index === 0){

                        // if(loginUser.usrInfoId == targetHsptl){
                        //     handleHsptlChange('', targetHsptl);
                        // }else{
                        //     handleHsptlChange('', item.hsptlCd);
                        // }

                        // if(loginUser.usrInfoId == targetHsptl.split(":")[1]){
                        //     handleHsptlChange('', targetHsptl.split(":")[0]);
                        // }else{
                        //     handleHsptlChange('', item.hsptlCd);
                        // }

                    //}
                // });

            }

        }else{
            handleHsptlChange('',t);
        }




        /*
        if(t == null){
            Array.isArray(hsptlRsvtList) &&
            hsptlConnectedInfo.map((item, index) => {
                if(index === 0){
                    handleHsptlChange('', item.hsptlCd);
                }
            });

            if(hsptlCd !== ''){
                handleHsptlChange('',hsptlCd)
            }
        }else{
            handleHsptlChange('',t);
        }
        */

    }, [hsptlConnectedInfo])

    const handleHsptlChange = (event, newValue) => {

        //sessionStorage.setItem("targetHsptl", newValue+":"+loginUser.usrInfoId);
        sessionStorage.setItem("targetHsptl", newValue);

        setValue(newValue);
        setTabParam(newValue);

        let loopCount = 0;
        Array.isArray(hsptlRsvtList) &&
        hsptlRsvtList.map((item, index2) => {
            if(item.hsptlCd === newValue){
                loopCount++;
            }
        });

        if(loopCount === 0){
            setSchedule("resvNot");
        }else{
            changeTabFirst(newValue);
        }

    };


    const changeTabFirst = (hsptlCd) => {

        let loopCount = 0;
        Array.isArray(hsptlConnectedInfo) &&
        hsptlConnectedInfo.map((item, index) => {
            if(item.hsptlCd === hsptlCd){
                hsptlRsvtList.map((item2, index2) => {
                    if(item2.hsptlCd === hsptlCd){
                        if(loopCount === 0){
                            setSchedule(item2.hsptlCd+"_"+item2.resvDt);
                            loopCount++;
                        }
                    }
                })
            }
        });

    };


    const formatApptDate = (apptDate) => {
        if (!apptDate || apptDate.length !== 8) return '';

        const year = parseInt(apptDate.substring(0, 4), 10);
        const month = parseInt(apptDate.substring(4, 6), 10) - 1; // JS month는 0부터 시작
        const day = parseInt(apptDate.substring(6, 8), 10);

        const targetDate = new Date(year, month, day);
        const today = new Date();

        // 날짜 비교를 위해 시각 제거
        today.setHours(0, 0, 0, 0);
        targetDate.setHours(0, 0, 0, 0);

        const diffInMs = targetDate - today;
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        if (diffInDays === 0) return '오늘 진료';
        if (diffInDays > 0) return diffInDays + '일후';


        return '';
    }

    const formatDate = (dateStr) => {

        if (!dateStr || dateStr.length !== 8) return ""; // 잘못된 형식 방어
        const year = dateStr.slice(2, 4);  // "25"
        const month = dateStr.slice(4, 6); // "06"
        const day = dateStr.slice(6, 8);   // "01"

        return `${year}.${month}.${day}`; // "25.06.01"
    }



    function getAppointmentMessage(targetDateStr) {
        // 오늘 날짜 자동 생성 (YYYYMMDD)
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const todayDateStr = `${yyyy}${mm}${dd}`;

        // 문자열을 날짜 객체로 변환 (YYYYMMDD)
        const toDate = (str) => {
          const year = parseInt(str.slice(0, 4), 10);
          const month = parseInt(str.slice(4, 6), 10) - 1;
          const day = parseInt(str.slice(6, 8), 10);
          return new Date(year, month, day);
        };

        const targetDate = toDate(targetDateStr);
        const todayDate = toDate(todayDateStr);

        const msPerDay = 1000 * 60 * 60 * 24;
        const diffDays = Math.floor((targetDate - todayDate) / msPerDay);

        if (diffDays === 0) {
          return "<p>오늘은 <b>진료당일</b> 입니다.</p>";
        } else if (diffDays > 0) {
          return `${diffDays}`;
        } else {
          return "이미 진료일이 지났습니다.";
        }
    }

    const isToday = (dateStr) => {
        // 오늘 날짜를 YYYYMMDD 형태로 만들기
        const today = new Date();
        const yyyy = today.getFullYear().toString();
        const mm = (today.getMonth() + 1).toString().padStart(2, '0');
        const dd = today.getDate().toString().padStart(2, '0');
        const todayStr = yyyy + mm + dd;
        return dateStr === todayStr;
    }




    // bottom Sheet
    const [open, setOpen] = useState(false);
    const [reserOpen, setReserOpen] = useState(false);  // 진료예약 바텀 시트
    const [locationOpen, setLocationOpen] = useState(false);
    const [advanceOpen, setAdvanceOpen] = useState(false);
    const [advanceMsg, setAdvanceMsg] = useState("");

    const resvBtnRef = useRef(null); // 진료예약 버튼 ref
    const innerSheetRef = useRef(null); // 바텀시트 내부 ref

      useEffect(() => {
            setOpen(false);
            setReserOpen(false);
            setLocationOpen(false);
            setAdvanceOpen(false);
      }, []);

      function onDismiss() {
          setOpen(false);
          setReserOpen(false);
          setLocationOpen(false);
          setAdvanceOpen(false);
      }


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    const handleSchedule = (event, newValue) => {
        setSchedule(newValue);
    };

    //날짜 탭2
    const [schedule2, setSchedule2] = React.useState('1');

    const handleSchedule2 = (event, newValue) => {
        setSchedule2(newValue);
    };



    /***  공지사항 ****/
    const hosptCd = value;

    //데이터
    const [noticeList, setNoticeList] = useState([]);
    const isSendingRef = useRef(false);

    const notiInfoParam = {
        hsptlCd: hosptCd,
        boardCd: "notice",
        pageNo: 1,
        keyword: ""
    };


    //데이터 불러오기
    const getNotiInitInfo = useCallback(async () => {

        if (isSendingRef.current) return;
        isSendingRef.current = true;




        setIsLoading(true);

        const url = "/guide/board/retrieveBoardList";

        const t = searchParams.get('t');
        const notiInfoParamExt = {
            ...notiInfoParam,
            hsptlCd : t
        }

        try {
            const res = await axiosApi.post(url, notiInfoParamExt);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const notiBundle = res.data.result.faqInfo;
                const parsed = JSON.parse(notiBundle);
                setNoticeList(parsed.slice(0, 3));
            } else {
                setNoticeList([]);
            }
        } catch (err) {
            console.log(err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    }, [hosptCd]);


    // useEffect(() => {
    //     getNotiInitInfo();
    // }, [getNotiInitInfo]);

    useEffect(() => {
    if (!hosptCd) return; // 병원 코드 없을 땐 실행 안 함
    getNotiInitInfo();
    }, [hosptCd]); // 병원 탭 변경 시마다 호출


    //장기 기증 사이트 이동
    const getOrganDonationLink = (value) => {
        switch (value) {
        case "012":
            return "https://www.cmcseoul.or.kr/transplantation/index.do";
        case "013":
            return "https://www.cmcujb.or.kr/page/department/C/1575/1";
        case "014":
            return "https://www.cmcbucheon.or.kr/page/department/C/1245/1";
        case "015":
            return "https://www.cmcep.or.kr/page/department/C/1436/1";
        case "016":
            return "https://www.cmcism.or.kr/treatment/center_info?deptSeq=141";
        case "018":
            return "https://www.cmcdj.or.kr/servlet/ContentsSvl?_tc=CONTENTS00000&cd2=001&cd3=001&cd4=004&cd5=016";
        default:
            return null;
        }
    };

    const link = getOrganDonationLink(value);

    const handleBackClick = () => {
        navigate(URL.APP_SETTINGS, { replace: true });
        
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
            navigate(URL.MY_HOSPITAL_SETTING);
            });
        });
    };

    //이미지 관련
    const [showFullImage, setShowFullImage] = useState(false);
    const [saveImgUrl, setSaveImgUrl] = useState('');

    //이미지 크게보기
    const handleViewFullImage = (imageUrl) => {
        setSaveImgUrl(imageUrl);
        setShowFullImage(true);
        setOpen(false);
    };

    const handleCloseFullImage = () => {
        setShowFullImage(false);
    };


    // IOS 새창 - 유틸 함수 추가
    const openExternalUrl = (url) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: url
            }));
        } else {
            window.open(url, '_blank');
        }
    };

    const formatTimeAmPm = (timeStr) => {
        const hour = parseInt(timeStr.substring(0, 2), 10);
        const minute = timeStr.substring(2, 4);
        const period = hour < 12 ? '오전' : '오후';
        const displayHour = String(hour % 12 || 12).padStart(2, '0');
        return `${period} ${displayHour}:${minute}`;
    }

    const formatDateWithDay =(dateStr) => {
        const year = dateStr.substring(2, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        const date = new Date(
            parseInt(dateStr.substring(0, 4), 10),
            parseInt(month, 10) - 1,
            parseInt(day, 10)
        );
        const weekday = days[date.getDay()];
        return `${year}.${month}.${day}(${weekday})`;
    }

    const isWithinNonfaceTime = (resvDt, bgngTm, endTm) => {
        const now = new Date();
        const year = parseInt(resvDt.substring(0, 4), 10);
        const month = parseInt(resvDt.substring(4, 6), 10) - 1;
        const day = parseInt(resvDt.substring(6, 8), 10);

        const bgngDate = new Date(year, month, day,
            parseInt(bgngTm.substring(0, 2), 10),
            parseInt(bgngTm.substring(2, 4), 10)
        );
        const endDate = new Date(year, month, day,
            parseInt(endTm.substring(0, 2), 10),
            parseInt(endTm.substring(2, 4), 10)
        );

        return now >= bgngDate && now <= endDate;
    }

    const groupedRsvtInfoList = useMemo(() => {
        if (!Array.isArray(hsptlRsvtInfoList)) return [];
        const map = {};
        hsptlRsvtInfoList.forEach((item) => {
            if (item.stat === "X") return;
            const key = item.hsptlCd + "_" + item.resvDt + "_" + item.deptCd + "_" + item.doctrCd;
            if (!map[key]) {
                map[key] = {
                    ...item,
                    tabKey: item.hsptlCd + "_" + item.resvDt,
                    items: [],
                    totalClnicCnt: 0,
                    totalClnicExmnCnt: 0,
                    totalNoFaceClnicCnt: 0,
                };
            }
            map[key].items.push(item);
            map[key].totalClnicCnt += (item.clnicCnt || 0);
            map[key].totalClnicExmnCnt += (item.clnicExmnCnt || 0);
            map[key].totalNoFaceClnicCnt += (item.noFaceClnicCnt || 0);
        });
        return Object.values(map);
    }, [hsptlRsvtInfoList]);

    return (

        <>
            <Header menu="hospitalcare" />

            <div className="container" data-posi='fixed'>

            {   /*  연결된 병원이 없을 경우 */

                // (()=>{
                //      if(hsptlConnectedInfo.length === 0){
                //          return(
                //              <div className={style['no-hospital-box']}>
                //                  < EmptyContentBox target="on" />
                //              </div>
                //          )
                //      }
                // })()
            }


            {isLoading && !hasFetched ? (
                 <div className={style['loading-container']}>
                    <div className={style['loading-top']}>
                        <Skeleton variant="text" height={35} width={80}/>
                        <Skeleton variant="text" height={35} width={80}/>
                        <Skeleton variant="text" height={35} width={80}/>
                    </div>
                    <div className={style['loading-mid']}>
                        <Skeleton variant="text" height={30} width={200}/>
                        {/* <div className={style['mid-top']}>
                            <Skeleton variant="text" height={34} width={80} style={{borderRadius: 20}}/>
                            <Skeleton variant="text" height={34} width={80} style={{borderRadius: 20}}/>
                            <Skeleton variant="text" height={34} width={80} style={{borderRadius: 20}}/>
                        </div> */}
                        <Skeleton variant="rounded" width={'100%'} height={70} sx={{  mt: '10px' }} style={{borderRadius: 12}}/>
                    </div>
                    <div className={style['loading-bot']}>
                        <div className='inner-wrap'>
                            <div className={style['my-medic-inform']}>
                                <div className='h2-box'>
                                    <h2><Skeleton variant="text" height={24} width={120}/></h2>
                                </div>
                                <div className='list-box' data-list-num='3'>
                                    <ul>
                                        <li><Skeleton variant="rounded" height={75} style={{borderRadius: 12}}/></li>
                                        <li><Skeleton variant="rounded" height={75} style={{borderRadius: 12}}/></li>
                                        <li><Skeleton variant="rounded" height={75} style={{borderRadius: 12}}/></li>
                                    </ul>
                                </div>
                            </div>

                            <div className={style['hospital-inform-box']}>
                                <h2 className='h2'><Skeleton variant="text" height={24} width={100}/></h2>

                                <div className={style['top-box']}>
                                    <div className='list-box' data-list-num='4'>
                                        <ul>
                                            <li><Skeleton variant="text" height={75} style={{borderRadius: 12}}/></li>
                                            <li><Skeleton variant="text" height={75} style={{borderRadius: 12}}/></li>
                                            <li><Skeleton variant="text" height={75} style={{borderRadius: 12}}/></li>
                                            <li><Skeleton variant="text" height={75} style={{borderRadius: 12}}/></li>
                                        </ul>
                                    </div>
                                </div>
                             </div>

                            <div className={style['hospital-not ice']}>
                                <div className='h 2-box'>
                                    <h2><Skeleton variant="text" height={24} width={100} style={{borderRadius: 12}}/></h2>
                                </div>
                                <div className='inner-box'>
                                    <div> <Skeleton variant="text" height={22} width={200} /></div>
                                    <div> <Skeleton variant="text" height={22} width={200} /></div>
                                    <div> <Skeleton variant="text" height={22} width={200} /></div>
                                </div>
                            </div>


                            <div className={style['hospital-sharing']}>
                                <h2 className='h2'><Skeleton variant="text" height={22} width={100} /></h2>

                                <div className='list-box' data-list-num='2x2' data-icon-pos='left'>
                                    <ul>
                                        <li data-icon='1'>
                                            <Skeleton variant="rounded" height={55} />
                                        </li>
                                        <li data-icon='1'>
                                            <Skeleton variant="rounded" height={55} />
                                        </li>
                                        <li data-icon='1'>
                                            <Skeleton variant="rounded" height={55} />
                                        </li>
                                        <li data-icon='1'>
                                            <Skeleton variant="rounded" height={55} />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                 </div>

            ): hasFetched && hsptlConnectedInfo.length === 0 ? (
                <div className={style['no-hospital-box']}>
                    <EmptyContentBox target="on" />
                </div>
            ) : hasFetched && hsptlConnectedInfo.length > 0 ? (
                <TabContext value={value} className="tab-context">
                    <div className="top-tab-head" data-tab="d-day" data-posi='fixed'>
                        <TabList
                            onChange={handleHsptlChange}
                            aria-label="lab API tabs example"
                            variant="scrollable"
                            scrollButtons={false}
                            className={style['tab-lists']}
                        >

                            {hsptlConnectedInfo.map((info, item1Index) => {
                                    //if (!info.apptDate) return null; // apptDate가 null이면 렌더링하지 않음
                                return(
                                    <Tab
                                        onClick={()=>{
                                            setOpen(false)
                                        }}
                                        key={info.hsptlCd}
                                        value={info.hsptlCd}
                                        label={
                                            <p>
                                                {info.hsptlNm}
                                                {formatApptDate(info.apptDate) && (
                                                    <span className="d-day">{formatApptDate(info.apptDate)}</span>
                                                )}
                                            </p>
                                        }
                                        disableRipple
                                        className={formatApptDate(info.apptDate) ? 'has-date' : ''}
                                    />
                                )
                            })}


                        </TabList>

                        {hsptlConnectedInfo.length >= 1 && (
                            <div className={style['side-btn-box']}>
                                <button onClick={()=> handleBackClick()}>
                                <span className='blind'>내 병원 설정</span>
                            </button>
                            </div>
                        )}

                    </div>


                    {hsptlConnectedInfo.map((info, index) => {
                            //if (!info.apptDate) return null; // apptDate가 null이면 렌더링하지 않음
                            let item2Cnt = 0;
                            return(

                                <TabPanel value={info.hsptlCd} key={info.hsptlCd}>

                                    <div className={style['hospital-top-titlebox']}>
                                        <p>{info.hsptlNm} 진료/검사 일정 </p>
                                        <button className='btn' data-btn-icon="calender" ref={resvBtnRef} onClick={() => {
                                            setReserOpen(true);
                                            setTimeout(() => {
                                                if (innerSheetRef.current) {
                                                    innerSheetRef.current.focus({ preventScroll: true });
                                                }
                                            }, 200);
                                            setResvInfo({
                                                hsptlCd : info.hsptlCd,
                                                hsptlNm : info.hsptlNm
                                            });
                                        }}>
                                            <span>진료 예약</span>
                                        </button>
                                    </div>


                                    <TabContext value={schedule}>
                                        <div className="top-tab-head" data-type="b" data-letter="small">
                                            <TabList
                                                onChange={handleSchedule}
                                                variant="scrollable"
                                                scrollButtons={false}
                                                className={style["tab-lists"]}
                                            >

                                        {
                                            Array.isArray(hsptlRsvtList) &&
                                            hsptlRsvtList.map((item2, index2) => {
                                                if (info.hsptlCd === item2.hsptlCd) {
                                                    let item2Limit = 5;
                                                    if(item2Cnt < item2Limit){
                                                        item2Cnt++
                                                        return (
                                                            // x건 이상일 때 표시
                                                            <Tab key={item2.hsptlCd + "_" + item2.resvDt} label={formatDate(item2.resvDt)} value={item2.hsptlCd+"_"+item2.resvDt} disableRipple />
                                                        )
                                                    }else{
                                                        if(item2Cnt == item2Limit){
                                                            return (
                                                                //  x건 이상일 때, 더보기 표시
                                                                <></>
                                                            )
                                                        }
                                                    }
                                                }
                                            })

                                        }
                                        {
                                            item2Cnt > 0 && (
                                                <>
                                               
                                                    <Tab label="더보기" value="more" disableRipple  onClick={()=> navigate(URL.HOSPITAL_MEDICALRESERVATIONHISTORY, {
                                                        state: {
                                                            hsptlCd: info.hsptlCd,
                                                            hsptlNm: info.hsptlNm,
                                                            deptCd: info.deptCd,
                                                            patntId: info.patntId
                                                        }
                                                    })} />
                                                </>
                                            )
                                        }
                                            </TabList>
                                        </div>
                                        {
                                            [...new Set(
                                                groupedRsvtInfoList
                                                    .filter(g => g.hsptlCd === info.hsptlCd)
                                                    .map(g => g.tabKey)
                                            )].map(tabKey => (
                                                <TabPanel key={tabKey} value={tabKey}>
                                                    {groupedRsvtInfoList
                                                        .filter(group => group.tabKey === tabKey)
                                                        .map((group, index3) => (
                                                        <div key={group.hsptlCd + "_" + group.resvDt + "_" + group.deptCd + "_" + group.doctrCd} className='inner-wrap' data-botm-padding="0">
                                                            <div className={style['hospital-sch-wrap']}>
                                                                <div className='inner-box'>

                                                                        {/* 담당의사 정보 */}
                                                                        <div className={style['top-box']} onClick={()=> navigate(URL.HOSPITAL_MEDICALRESERVATIONDETAILSIN, {
                                                                            state: {
                                                                                hsptlNm: info.hsptlNm,
                                                                                hsptlCd: group.hsptlCd,
                                                                                deptCd: group.deptCd,
                                                                                patntId: group.patntId,
                                                                                doctrCd : group.doctrCd,
                                                                                resvDt: group.resvDt,
                                                                                resvTm: group.resvTm
                                                                            }
                                                                        })}>
                                                                            <div className={style['head']}>
                                                                                <div className={style['hospital-type']}>
                                                                                <p className={
                                                                                    group.noFaceClnicCnt === 1
                                                                                    ? style['h-out']
                                                                                    : style['h-in']
                                                                                    }>
                                                                                        {group.noFaceClnicCnt === 1 ? '비대면 진료' : '외래 진료'}
                                                                                    </p>
                                                                                {/* <p className={style['h-out']}>비대면 진료</p>  */}
                                                                                </div>
                                                                                <div className={style['date-box']}>
                                                                                    <strong>{formatDateWithWeekday(group.resvDt)}</strong>
                                                                                    <p>{formatTime24(group.resvTm)}</p>
                                                                                </div>
                                                                            </div>

                                                                            <div className={style['mid']}>
                                                                                <ul>
                                                                                    <li>
                                                                                        <div className={style['avatar']}>
                                                                                            <Avatar
                                                                                                alt="샘플 이미지"
                                                                                                src={group.doctrImgUrl}
                                                                                                sx={{ width: 48, height: 48 }}
                                                                                            />
                                                                                            <div className={style['avatar-infom']}>
                                                                                                <p>{group.deptNm}</p>
                                                                                                <span>{group.doctrNm} 교수</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className={style['medical-inform']}>
                                                                                            <div className={style['medic-notice']}>
                                                                                                {
                                                                                                    (() => {
                                                                                                        if (isToday(group.resvDt)) {
                                                                                                            return <><p>오늘은 <b>진료당일</b> 입니다.</p></>;
                                                                                                        } else {
                                                                                                            return <><p>진료 예정일까지 <b>{getAppointmentMessage(group.resvDt)}일</b> 남았습니다.</p></>;
                                                                                                        }
                                                                                                    })()
                                                                                                }
                                                                                            </div>

                                                                                            {/* ★ 합산된 건수 표시 */}
                                                                                            <div className={style['medic-list']}>
                                                                                                <p>진료 <b>{group.noFaceClnicCnt >= 1 ? group.totalNoFaceClnicCnt : group.totalClnicCnt}</b></p>
                                                                                                {group.noFaceClnicCnt < 1 && <p>검사 <b>{group.totalClnicExmnCnt}</b></p>}
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>

                                                                                </ul>
                                                                            </div>
                                                                        </div>

                                                                        {
                                                                            /* 금일 진료일 경우에만 출력 */
                                                                            (() => {
                                                                                if (isToday(group.resvDt)) {
                                                                                    return (
                                                                                        <>

                                                                        {/* 진료 스케줄 */}
                                                                        <div className={style['middle-box']}>
                                                                            <p>오늘 진료/검사 내역</p>

                                                                            {/**** 외래진료일 경우 :: S *****/}
                                                                            <div className={style['history-box']} data-history-box={group.noFaceClnicCnt === 1 ? 'out' : ''}>
                                                                                <ul>

                                                                                    {
                                                                                        Array.isArray(hsptlRsvtClnicList) &&
                                                                                        hsptlRsvtClnicList.map((item4, index4) => {

                                                                                            // 진료 / 검사 — 그룹 내 모든 항목의 resvTm과 매칭
                                                                                            if(group.hsptlCd === item4.hsptlCd && group.items.some(gi => gi.deptCd === item4.deptCd && gi.doctrCd === item4.doctrCd && gi.resvTm === item4.resvTm)){

                                                                                                if(item4.clnicExmnType == 'E'){
                                                                                                    return (
                                                                                                        <li key={item4.hsptlCd + "_" + item4.resvDt + "_" + index4} className={style['history-list']} data-list-type='a'>
                                                                                                            <div className={style['history-head']}>
                                                                                                                <div className={style['his-date']}>
                                                                                                                    <strong>검사</strong>
                                                                                                                    <p>{formatTime24(item4.resvTm)}</p>
                                                                                                                </div>
                                                                                                                {/* <div className={style['history-mid']}>
                                                                                                                    <strong>{item4.deptNm}</strong>
                                                                                                                    <p>{item4.doctrNm} 교수</p>
                                                                                                                </div> */}
                                                                                                                <div className={style['history-bot']}>
                                                                                                                    <span data-icon='doc'>{item4.guideMsg}</span>
                                                                                                                    <span data-icon='location'>{item4.place}</span>
                                                                                                                </div>
                                                                                                                <div className={style['btn-boxs']}>
                                                                                                                    <button className='btn' data-btn-type="fill-gray" data-btn-size='smd'  onClick={()=>{
                                                                                                                        setAdvanceOpen(true);
                                                                                                                        setAdvanceMsg(item4.guideMsg);
                                                                                                                    }}>
                                                                                                                        <span>사전 안내</span>
                                                                                                                    </button>
                                                                                                                    <button className='btn' data-btn-type="fill-gray" data-btn-size='smd'  onClick={()=>{
                                                                                                                        setPlaceInfo({
                                                                                                                            place : item4.place,
                                                                                                                            deptImgUrl : item4.deptImgUrl
                                                                                                                        })

                                                                                                                        setLocationOpen(true);
                                                                                                                    }}>
                                                                                                                        <span>위치보기</span>
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </li>
                                                                                                    )
                                                                                                }else if(item4.clnicExmnType == 'N'){

                                                                                                    // item4 루프 안에서 매칭되는 비대면 데이터 찾기
                                                                                                    const nonfaceItem = hsptlRsvtClnicNonfaceList?.find(nf =>
                                                                                                        nf.chrgHsptlCd === item4.hsptlCd &&
                                                                                                        nf.rsvctmPatntNo === item4.patntId &&
                                                                                                        nf.chrgDeptNm === item4.deptNm
                                                                                                    );

                                                                                                    const canEnter = nonfaceItem
                                                                                                        ? isWithinNonfaceTime(item4.resvDt, nonfaceItem.telmdcBgngDt, nonfaceItem.telmdcEndDt)
                                                                                                        : false;

                                                                                                    return (
                                                                                                        <>

                                                                                        <li className={style['history-list']}>
                                                                                            <div className={style['history-head']}>
                                                                                                <div className={style['his-date']}>
                                                                                                    <strong>진료</strong>
                                                                                                    <p>{formatTime24(item4.resvTm)}</p>
                                                                                                </div>
                                                                                                <div className={style['history-mid']}>
                                                                                                    <strong>{item4.deptNm}</strong>
                                                                                                    <p>{item4.doctrNm} 교수</p>
                                                                                                </div>




                                                                                                <div className={style['btn-boxs']}>
                                                                                                    <button className='btn' data-btn-type="fill-main" data-btn-size='smd' disabled={!canEnter} onClick={() => {
                                                                                                            if (nonfaceItem?.joinUrl) {
                                                                                                                window.open(nonfaceItem.joinUrl, '_blank');
                                                                                                            }
                                                                                                        }}>
                                                                                                        <span>진료실 입장하기</span>
                                                                                                    </button>
                                                                                                    <button className='btn' data-btn-type="fill-gray" data-btn-size='smd'  onClick={()=>{
                                                                                                        setAdvanceOpen(true);
                                                                                                        setAdvanceMsg(item4.guideMsg);
                                                                                                    }}>
                                                                                                        <span>사전 안내</span>
                                                                                                    </button>
                                                                                                </div>
                                                                                                <div className={style['notice-txts']}>
                                                                                                    <p>
                                                                                                        {nonfaceItem
                                                                                                            ? `${formatDateWithDay(item4.resvDt)} ${formatTimeAmPm(nonfaceItem.telmdcBgngDt)}부터 ${formatTimeAmPm(nonfaceItem.telmdcEndDt)}까지`
                                                                                                            : ''
                                                                                                        }
                                                                                                    </p>
                                                                                                    <span>진료실 입장이 가능합니다</span>
                                                                                                </div>





                                                                                                {/* <div className={style['btn-boxs']}>
                                                                                                    <button className='btn' data-btn-type="fill-main-sub" data-btn-size='smd'>
                                                                                                        <span>진료비 수납하기</span>
                                                                                                    </button>
                                                                                                    <button className='btn' data-btn-type="fill-main-sub" data-btn-size='smd'>
                                                                                                        <span>처방전 확인하기</span>
                                                                                                    </button>
                                                                                                </div> */}


                                                                                            </div>
                                                                                        </li>


                                                                                                        </>
                                                                                                    )
                                                                                                }else{
                                                                                                    return(

                                                                                                        <li key={`${item4.hsptlCd}_${item4.resvDt}_${index4}`} className={style['history-list']}>
                                                                                                            <div className={style['history-head']}>
                                                                                                                <div className={style['his-date']}>
                                                                                                                    <strong>진료</strong>
                                                                                                                    <p>{formatTime24(item4.resvTm)}</p>
                                                                                                                </div>
                                                                                                                <div className={style['history-mid']}>
                                                                                                                    <strong>{item4.deptNm}</strong>
                                                                                                                    <p>{item4.doctrNm} 교수</p>
                                                                                                                </div>
                                                                                                                <div className={style['history-bot']}>
                                                                                                                    <span data-icon='location'>{item4.place}</span>
                                                                                                                </div>

                                                                                                                <div className={style['btn-boxs']}>
                                                                                                                    <button className='btn' data-btn-type="fill-gray" data-btn-size='smd' onClick={()=>{
                                                                                                                        setPlaceInfo({
                                                                                                                            place : item4.place,
                                                                                                                            deptImgUrl : item4.deptImgUrl
                                                                                                                        })

                                                                                                                        setLocationOpen(true);
                                                                                                                    }}>
                                                                                                                        <span>위치보기</span>
                                                                                                                    </button>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </li>

                                                                                                    )
                                                                                                }

                                                                                            }
                                                                                        })
                                                                                    }


                                                                                </ul>
                                                                            </div>
                                                                            {/**** 외래진료일 경우 :: E *****/}


                                                                            {/**** 비대면진료일 경우 :: S*****/}
                                                                            {/**** 비대면진료일 경우 :: E *****/}

                                                                        </div>

                                                                                        </>
                                                                                        /* 금일 진료일 경우에만 출력 */
                                                                                    )
                                                                                }
                                                                            })()
                                                                        }



                                                                    </div>
                                                                </div>
                                                            </div>
                                                    ))}
                                                </TabPanel>
                                            ))}


                                        {
                                            item2Cnt == 0 && (

                                                <TabPanel value="resvNot">

                                                    <div className={style['no-schedule-box']}>
                                                        <div className={style['in-box']}>
                                                            <p>다가오는 진료/검사 일정이 없습니다.</p>
                                                            <button className='btn' data-btn-type="fill-main" data-btn-size='sm' data-btn-icon='arrow' onClick={()=> navigate(URL.HOSPITAL_MEDICALRESERVATIONHISTORY, {
                                                                state: {
                                                                    hsptlCd: info.hsptlCd,
                                                                    hsptlNm: info.hsptlNm,
                                                                    deptCd: info.deptCd,
                                                                    patntId: info.patntId
                                                                }
                                                            })}>
                                                                <span>지난 진료 예약 내역 조회</span>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </TabPanel>

                                            )

                                        }

                                    </TabContext>

                                    <div className='inner-wrap'>
                                    {/* 병원 진료 내역 */}
                                    <div className={style['my-medic-inform']}>

                                        <div className='h2-box'>
                                            <h2>{info.hsptlNm} 진료 내역</h2>
                                        </div>

                                        <div className='list-box' data-list-num='3'>
                                            <ul>
                                                <li data-icon='2'>
                                                    <Link to={URL.HOSPITAL_MEDICALHISTORY} state={{
                                                            hsptlCd: info.hsptlCd,
                                                            hsptlNm: info.hsptlNm,
                                                            deptCd: info.deptCd,
                                                            patntId: info.patntId
                                                        }}
                                                        draggable={false}
                                                        >
                                                        <p>진료 내역</p>
                                                    </Link>
                                                </li>
                                                <li data-icon='3'>
                                                    <Link to={URL.HOSPITAL_PRESCRIPTIONHISTORY} state={{
                                                            hsptlCd: info.hsptlCd,
                                                            hsptlNm: info.hsptlNm,
                                                            patntId: info.patntId
                                                        }}
                                                        draggable={false}
                                                        >
                                                        <p>약물 처방 내역</p>
                                                    </Link>
                                                </li>
                                                <li data-icon='1'>
                                                    <Link to={URL.HOSPITAL_INSPECTIONHISTORY} state={{
                                                            hsptlCd: info.hsptlCd,
                                                            hsptlNm: info.hsptlNm,
                                                            patntId: info.patntId
                                                        }}
                                                        draggable={false}
                                                        >
                                                        <p>검사 내역</p>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>


                                    {/* 병원이용안내 */}
                                    <div className={style['hospital-inform-box']}>
                                        <h2 className='h2'>{info.hsptlNm}병원 이용안내</h2>

                                            <div className={style['top-box']}>
                                                <div className='list-box' data-list-num='4'>
                                                    <ul>
                                                        <li data-icon='1'><Link to={URL.HOSPITAL_HOSPITALINFORMATION} state={{ hsptlCd: value }} draggable={false}><p>병원 정보</p></Link></li>
                                                        <li data-icon='2'><Link to={URL.HOSPITAL_AMENITY} state={{ hsptlCd: value }} draggable={false}><p>편의 시설</p></Link></li>
                                                        <li data-icon='3'><Link to={URL.HOSPITAL_DIRECTIONS} state={{ hsptlCd: value }} draggable={false}><p>오시는 길</p></Link></li>
                                                        <li data-icon='4'><Link to={URL.HOSPITAL_PARKING} state={{ hsptlCd: value }} draggable={false}><p>주차 안내</p></Link></li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className={style['bottom-box']}>
                                                <div className='list-box'>
                                                    <ul>
                                                        <li data-icon='5'><Link to={URL.HOSPITAL_PARENTALSETTINGS} state={{ hsptlNm: info.hsptlNm, hsptlCd: info.hsptlCd }} draggable={false}><p>가족 / 보호자 설정</p></Link></li>
                                                    </ul>
                                                </div>
                                            </div>
                                    </div>

                                    {/* 공지사항 */}
                                    {value !== '016' && value !== '018' && (  // [인천, 대전] 은 공지사항이 없어 제외
                                        <div className={style['hospital-notice']}>
                                            <div className='h2-box'>
                                                <h2>{info.hsptlNm}병원 공지사항</h2>
                                                <button className={style['more-btn']} onClick={() => {
                                                        navigate(URL.HOSPITAL_NOTICELISTS, {
                                                            state: {
                                                                hsptlCd: info.hsptlCd
                                                            },
                                                            });
                                                        }
                                                    }>
                                                    <span>전체보기</span>
                                                </button>
                                            </div>

                                            <div className='inner-box'>
                                                <div className='notice-list-box'>
                                                    <ul>
                                                        {isLoading ? (
                                                            Array.from({ length: 3 }).map((_, index) => (
                                                            <li key={index}>
                                                                <p> <Skeleton variant="text" height={22} width={200} /></p>
                                                                <span><Skeleton variant="text" height={22} width={60} /></span>
                                                            </li>
                                                            ))
                                                        ) : noticeList.map((noti, index) => (
                                                            <li
                                                                key={`${noti.boardSn || index}`}
                                                                onClick={() => {
                                                                    navigate(URL.HOSPITAL_NOTICEDETAIL, {
                                                                        state: {
                                                                            hospCd: info.hsptlCd,
                                                                            notiTl: noti.title,
                                                                            notiCnt: noti.readCnt,
                                                                            notiCont: noti.content,
                                                                            notiDate: noti.createdDt,
                                                                            noticeList,
                                                                            currentIndex: index,
                                                                        },
                                                                    });
                                                                }}
                                                            >
                                                            <p>{noti.title}</p>

                                                            {noti.noticeYn === "Y" && (
                                                                <b className={style['import']}>필독</b>
                                                            )}
                                                            <span className={style['noti-date']}>{new Date(noti.createdDt)
                                                                .toLocaleDateString('ko-KR', {
                                                                year: '2-digit',
                                                                month: '2-digit',
                                                                day: '2-digit',
                                                                })
                                                                .replace(/\.$/, '')}
                                                            </span>
                                                        </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )}


                                    {/* 서울성모 알림과 나눔 */}
                                    <div className={style['hospital-sharing']}>
                                        <h2 className='h2'>{info.hsptlNm} 알림과 나눔</h2>

                                        <div className='list-box' data-list-num='2x2' data-icon-pos='left'>
                                            <ul>
                                                {value !== "016" && value !== "018" && (  // 인천, 대전 제외
                                                <li data-icon='1'>
                                                    <Link to={URL.HOSPITAL_FAQLISTS} state={{ hosptCd: value }} draggable={false}>
                                                        <p>자주 찾는 질문</p>
                                                    </Link>
                                                </li>
                                                 )}
                                                {value === "012" && (  // 서울만 해당
                                                    <li data-icon='2'>
                                                        <div onClick={() => openExternalUrl("https://www.ihappynanum.com/Nanum/apiB/GLX2VY10CI")} style={{ cursor: 'pointer'}} draggable={false} data-type='list-link-box' className={style['list-link-box']}>
                                                            <p>기부 참여</p>
                                                        </div>
                                                    </li>
                                                )}

                                                {value !== "011" && (  // 여의도 제외
                                                    <li data-icon='3'>
                                                        <div onClick={() => openExternalUrl(link)} style={{ cursor: 'pointer'}} draggable={false} data-type='list-link-box' className={style['list-link-box']}>
                                                            <p>장기 기증</p>
                                                        </div>
                                                    </li>
                                                )}

                                                <li data-icon='3'>
                                                     <div onClick={() => openExternalUrl("https://songeui.catholic.ac.kr/ko/cadevar/information.do")} style={{ cursor: 'pointer'}} draggable={false} data-type='list-link-box' className={style['list-link-box']}>
                                                        <p>시신 기증</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>




                                </TabPanel>

                            )
                        })}

                </TabContext>
            ) : null}




            </div>


            <BottomSheet
                scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                expandOnContentDrag={false} // 내용 드래그로 확장 방지
                open={reserOpen}
                onDismiss={()=> {
                    setReserOpen(false);
                    setTimeout(() => {
                        if (resvBtnRef .current) {
                            resvBtnRef .current.focus({ preventScroll: true });
                            resvBtnRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    }, 200);
                }}
                snapPoints={({ minHeight }) => minHeight}
                blocking={false}
            >
                {/* 진료 예약  BottomSheet  */}
                <div ref={innerSheetRef} tabIndex={-1}>
                    <MedicalReservation
                        onClose={()=> {
                            onDismiss();
                            setTimeout(() => {
                                if (resvBtnRef .current) {
                                    resvBtnRef .current.focus({ preventScroll: true });
                                    resvBtnRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                }
                            }, 200);
                        }}
                        hsptlCd={resvInfo.hsptlCd}
                        hsptlNm={resvInfo.hsptlNm}
                    />
                </div>
            </BottomSheet>



            <BottomSheet
                scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                expandOnContentDrag={false} // 내용 드래그로 확장 방지
                open={locationOpen}
                onDismiss={onDismiss}
                snapPoints={({ minHeight }) => minHeight}
                blocking={false}
            >

                {/* 위치 보기 BottomSheet  */}
                <LocationInfoBox
                        onClose={onDismiss}
                        imageUrl={placeInfo.deptImgUrl}
                        location={placeInfo.place}
                        deptNm={""}
                        onViewFullImage={handleViewFullImage}
                    />

            </BottomSheet>


            <BottomSheet
                scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                expandOnContentDrag={false} // 내용 드래그로 확장 방지
                open={advanceOpen}
                onDismiss={onDismiss}
                snapPoints={({ minHeight }) => minHeight}
                blocking={false}
            >

                {/* 사전 안내 BottomSheet  */}
                <div className='bottomsheet-wrap'>
                    <div className='bottomsheet-inbox'>

                        <strong className='bottomsheet-title'>사전 안내</strong>

                        <div className='bottomsheet-contbox'>
                            <p className='notice-txt'>아래 안내 사항을 미리 숙지해주세요.</p>

                            <div className='bottomsheet-list-box' data-list-type="a">
                                <p>{advanceMsg}</p>
                            </div>
                        </div>

                        <button className='close-btn' onClick={onDismiss}>
                            <span className='blind'>팝업 닫기</span>
                        </button>

                    </div>
                </div>

            </BottomSheet>

            {/* 이미지 크게보기 컨퍼넌트 */}
            {showFullImage && (
                <LocationImageView
                    imgUrl={saveImgUrl}
                    visible={showFullImage}
                    onClose={handleCloseFullImage}
                />
                )}

            {/* 챗봇 메뉴 : 숨김 처리(2025.12.11) >> 2026.02.02. 다시 열어달라 요청 : 유호민 */}
                <DialBox />

            <Navbar />
        </>
    )
}



export default HospitalCare
